import moment from 'moment';
import calendarEventManager from '@modules/calendar/utils/calendar-event-manager';
import { EEventStatus } from '@modules/calendar/types/events';
import Api from '../../../common/services/api';
import * as exchangeUtil from '../utils/exchange';
import { EExchangeTypes } from '../definitions';
import * as networksReducer from '../../core/reducers/networks';
import * as functionsReducer from '../../network/reducers/functions';

export const FLEXCHANGE_ADD_EXCHANGE = 'flexchange/POST_EXCHANGE';

// Transform exchange event data for calendar display
function transformExchangeEventForCalendar(apiData, state) {
  const { network: { selected } } = state;

  // Get network data from Redux
  const network = networksReducer.findById(state, selected);

  // Get function data from Redux if it's a function exchange
  let functions = [];
  if (apiData.created_in?.type === 'function' && apiData.created_in?.ids) {
    functions = apiData.created_in.ids
      .map((id) => functionsReducer.findById(state, id))
      .filter(Boolean);
  }

  // Build function name string
  const functionName = functions.length > 0
    ? functions[0].name + (functions.length > 1 ? ` + ${functions.length - 1}` : '')
    : '';

  // Transform to calendar event format matching ExchangeEvent interface
  return {
    id: apiData.id,
    type: 'exchange',
    title: '', // Exchange events don't have titles in this format
    date: apiData.date,
    start_time: apiData.start_time,
    end_time: apiData.end_time,
    description: apiData.description,
    user_id: apiData.user_id,
    user: apiData.user,
    status:
      apiData.is_approved ? EEventStatus.APPROVED :
        apiData.response_status === EEventStatus.APPROVED ? EEventStatus.ACCEPTED :
          apiData.response_status === EEventStatus.DECLINED ? EEventStatus.REJECTED :
            apiData.exchange_status === EEventStatus.EXPIRED ? EEventStatus.EXPIRED : EEventStatus.OPEN,
    created_for: network?.name || '',
    function_name: functionName,
    created_in: {
      values: apiData.created_in?.ids || []
    },
    created_at: apiData.created_at
  };
}

export default (values) => async (dispatch, getState) => {
  const { network: { selected } } = getState();

  const payload = {
    type: values.type === 'network' ? 'ALL' : values.type.toUpperCase(),
    date: moment(values.date).format('YYYY-MM-DD'),
    description: values.description,
    start_time: exchangeUtil.convertTimeToMoment(
      values.start_time,
      moment(values.date)
    ).toISOString(),
    end_time: values.end_time ?
      exchangeUtil.convertTimeToMoment(values.end_time, moment(values.date)) :
      null,
    shift_id: values.shift_id,
  };

  if (values.type === EExchangeTypes.FUNCTION) payload.values = values.function_ids || [];
  if (values.type === EExchangeTypes.USER) payload.values = values.user_ids || [];

  const { data } = await Api.post(`/v2/networks/${selected}/exchanges`, payload);

  // Transform the API response to include missing function/network data from Redux
  const transformedEvent = transformExchangeEventForCalendar(data, getState());

  calendarEventManager.addEvent(transformedEvent);
  if (payload?.shift_id) {
    calendarEventManager.updateEvent(payload.shift_id, { exchange_id: data.id });
  }

  return dispatch({
    type: FLEXCHANGE_ADD_EXCHANGE,
    exchangeId: data.id,
    exchange: exchangeUtil.transfromExchange(data),
  });
};
